import { render, staticRenderFns } from "./RightItemView2.vue?vue&type=template&id=2cb2452f&scoped=true&"
import script from "./RightItemView2.vue?vue&type=script&lang=ts&"
export * from "./RightItemView2.vue?vue&type=script&lang=ts&"
import style0 from "./RightItemView2.vue?vue&type=style&index=0&id=2cb2452f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb2452f",
  null
  
)

export default component.exports